import { FileExcelOutlined, PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import ClientContext from "../../context/clients/client/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import ClientContextProvider from "../../context/clients/client/provider";
import SearchFilterCard from "../../components/general/filter-card";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import ClientTable from "../../components/client/client-table";
import ClientFilter from "../../components/client/client-filter";
import ExportToExcelModal from "../../components/general/excel/export-to-excel-modal";
import { IExportClientExcel, columnsExportClientExcel, defaultClientReportExportColumns } from "../../models/client/request";
import TemplateExportExcel from "../../components/general/excel/expor-excel";
import { addSearchToURL, getFiltersFromURL, getKeywordFromURL } from "../../utils/helpers/url";
import { debounce } from "lodash";
interface IProps {
  children?: React.ReactNode;
}

// sum array in js
const Client: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(getKeywordFromURL());
  const [exportModalVisible, setExportModalVisible] = useState(false)

  const { actions, loading, query } = useContext(ClientContext);

  useEffect(() => {
    const filters = getFiltersFromURL();
    actions.setQuery({
      page: 1,
      perPage: 10,
      filters: filters,
      keyword: search
    });
  }, []);

  const debouncedSearch = debounce((value: string | undefined) => {
    addSearchToURL(value);
    actions.setSearch(value);
  }, 300);

  useEffect(() => {
    debouncedSearch(search);
    return () => {
      debouncedSearch.cancel();
    };
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("clients")}
        subTitle={t("clients_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Button
            key={1}
            type="primary"
            onClick={() => {
              setExportModalVisible(true);
            }}
            icon={<FileExcelOutlined />}
          >
            {t("export_to_excel")}
          </Button>,
          // <Divider key={1} type="vertical" />,
          // <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
          //   <Button
          //     type="primary"
          //     onClick={() => {
          //       navigate(`/clients/create`);
          //     }}
          //     icon={<PlusOutlined />}
          //   >
          //     {t("add_client")}
          //   </Button>
          // </Can>,
        ]}
      />
      <ExportToExcelModal
        id="export-complaint"
        title={t("export_to_excel")}
        visible={exportModalVisible}
        toggleVisible={setExportModalVisible}
        width="50vw"
        defaultValues={
          {
            id: false,
            firstName: false,
            lastName: false,
            city: false,
            status: false,
            mobile: false,
            createdAt: false,
            ordersCount: true,
            addressesCount: true,
            primaryAddressName: true,
            primaryAddress: true,
            primaryArea: true,
            primaryDiscountArea: true,
            primaryAddressOutsideArea: true,
            primaryAddressOutsideDiscountArea: true,
          } as IExportClientExcel
        }
        loading={loading.includes("create")}
        onSubmit={async (columnsNames) => {
          // await a(columnsNames);
          const exported = await actions.exportExcel(columnsNames);
          if (exported) setExportModalVisible(false);
        }}
      >
        <TemplateExportExcel
          names={columnsExportClientExcel}
          checkedColumns={defaultClientReportExportColumns}
        />
      </ExportToExcelModal>
      <SearchFilterCard
        formId="client-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          const searchParams = new URLSearchParams(location.search);
          searchParams.delete("keyword");
          Object.keys(getFiltersFromURL()).forEach((key) =>
            searchParams.delete(key)
          );
          navigate(`${location.pathname}`, { replace: true });
          actions.setQuery({
            page: 1,
            perPage: query?.perPage,
            keyword: undefined,
            filters: [],
          });
          const form = document.getElementById("client-filter");
          if (form) {
            form.dispatchEvent(new Event("reset", { cancelable: true, bubbles: true }));
          }
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <ClientFilter />
      </SearchFilterCard>

      <ClientTable />
    </div>
  );
};

const ClientPage = () => {
  return (
    // ContextProvider
    <ClientContextProvider>
      <Client />
    </ClientContextProvider>
  );
};
export default ClientPage;
